window.addEventListener("DOMContentLoaded", () => {
  // override product description to text-align center
  const productDescription = document.querySelector(".product-description");

  productDescription
    .querySelector("span")
    .setAttribute("style", "text-align: center");

  const variantBlock = document.querySelector(".variant-block ");
  const varaintSelectorWrappers = variantBlock.querySelectorAll(
    ".container-with-divider"
  );

  varaintSelectorWrappers.forEach((varaintSelectorWrapper) => {
    const variantInputWrapper = varaintSelectorWrapper.querySelector(
      ".bundle-variant-input-wrap"
    );
    const variantId = variantInputWrapper.getAttribute("data-id");

    const variantInputs = varaintSelectorWrapper.querySelectorAll(
      ".bundle-variant-input"
    );
    variantInputs.forEach((variantInput) => {
      const label = variantInput.querySelector("label");

      // set active on load
      if (variantInput.getAttribute("data-id") == variantId) {
        label.classList.add("active");
      }

      variantInput.addEventListener("click", () => {
        const index = parseInt(
          variantInput.getAttribute("data-index")
        );

        // set color name:
        const currentColor = variantInput.getAttribute("data-value");
        const currentColorElement =
          varaintSelectorWrapper.querySelector(".current-color");
        currentColorElement.innerText = currentColor;

        // set color image
        let currentColorImage = variantInput.getAttribute("data-image");
        const currentColorImageElement = varaintSelectorWrapper.querySelector(
          ".selected-color-image"
        );

        currentColorImage = currentColorImage.split(".jpg").join("_960x.jpg");

        currentColorImageElement.setAttribute(
          "src",
          "//cdn.shopify.com/s/files/1/0144/2031/2118/" + currentColorImage
        );

        //set main product images
        const productPhotos = document.querySelector(".product__photos");
        const productImages =
          productPhotos.querySelectorAll(".photoswipe__image");
        const currentSlide = productImages[index];

        currentSlide.setAttribute(
          "srcset",
          "//cdn.shopify.com/s/files/1/0144/2031/2118/" + currentColorImage
        );

        // set data-images for photoswipe
        const photoswipeButtons = document.querySelectorAll(
          ".js-photoswipe__zoom"
        );
        photoswipeButtons.forEach((photoswipeButton) => {
          let photoSwipeImages = photoswipeButton.getAttribute("data-images");

          photoSwipeImages = photoSwipeImages.split(",");
          photoSwipeImages[index - 1] =
            "//cdn.shopify.com/s/files/1/0144/2031/2118/" +
            currentColorImage +
            "?";
          photoSwipeImages = photoSwipeImages.join(",");

          photoswipeButton.setAttribute("data-images", photoSwipeImages);

        });
        $(".bundle-image-slideshow").slick("slickGoTo", index - 1);

        //     //cdn.shopify.com/s/files/1/0636/4223/9224/products/VI-32354BTLG_01_960x.jpg?v=1656357003_1800x1800.jpg?v=1656357003

        // set active class

        // highlight selected swatch
        bundleDeselectLabels(varaintSelectorWrapper);

        setTimeout(() => {
          label.classList.add("active");
          
          updateBundlePrice();
          // handle Add to cart button

          activeVariantLabels = variantBlock.querySelectorAll(".active");
          let outOfStock = false;
          activeVariantLabels.forEach((activeVariantLabel) => {
            if (activeVariantLabel.classList.contains("disabled")) {
              outOfStock = true;
            }
          });
          if (outOfStock == true) {
            const atcForm = document.querySelector(".atc-block");
            const formOption = atcForm.querySelector("option");
            formOption.removeAttribute("value");
            formOption.removeAttribute("selected");
            const atcButton = atcForm.querySelector(".add-to-cart");
            atcButton.setAttribute("disabled", "disabled");
            atcButton.classList.add("disabled");
            atcButton.innerText = "Sold Out";
          } else {
            const atcForm = document.querySelector(".atc-block");
            const formOption = atcForm.querySelector("option");
            formOption.setAttribute("selected", "selected");
            formOption.removeAttribute("disabled");
            const atcButton = atcForm.querySelector(".add-to-cart");
            atcButton.removeAttribute("disabled");
            atcButton.classList.remove("disabled");
            atcButton.innerHTML = `<span data-add-to-cart-text data-default-text="Add to Bag" > Add To Bag </span>`;
          }
        }, 100);
      });
    });

  });

  const addToCartButton = document.querySelector(".add-to-cart.bundle");
  addToCartButton.addEventListener("click", (event) => {
    event.preventDefault();

    // get selected ids
    const selectedVariantIds = [];
    varaintSelectorWrappers.forEach((varaintSelectorWrapper) => {
      const activeSwatch = varaintSelectorWrapper.querySelector(".active");
      const selectedVariantId = activeSwatch
        .closest("div")
        .getAttribute("data-id");
      selectedVariantIds.push(selectedVariantId);
    });

    //  add those items to cart

    const items = selectedVariantIds.map((selectedVariantId) => {
      return {
        id: parseInt(selectedVariantId),
        quantity: 1,
      };
    });

    const data = { items: items };
    //debugger
    fetch(theme.routes.cartAdd, {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(
        function (data) {
          if (data.status === 422) {
            this.error(data);
            materialsModalATC.querySelector("span").innerText = "Error";
          } else {
            var product = data;
            console.log('bundle success!')
            //this.success(product);
            document.dispatchEvent(new CustomEvent("cart:build"));
            document.dispatchEvent(new CustomEvent("cart:open"));
          }
        }.bind(this)
      );
  });
  // update bundle price on page load
  updateBundlePrice();

  function updateBundlePrice(){

    // Find all elements with class 'bundle-variant-input-wrap'
    const containerElements = document.querySelectorAll('.bundle-variant-input-wrap');

    // Initialize variables for total price and compare at price
    let totalPrice = 0;
    let totalCompareAtPrice = 0;

    // Iterate through each container element
    containerElements.forEach(containerElement => {
      // Select active label elements inside the container element
      const activeLabels = containerElement.querySelectorAll('label.active');
      const allLabels = containerElement.querySelectorAll('label')
      let maxPrice = 0;

      // Iterate through each active label element
      activeLabels.forEach(label => {
        // Get the price value from the data-price attribute
        const price = parseFloat(label.dataset.price);

        // Add the price to the total price
        totalPrice += price;

        // Print the price that goes into the total price
        //console.log(`Price: ${price}`);

      });
      allLabels.forEach(label => {
        const price = parseFloat(label.dataset.price);
        // Update the max price if necessary
        if (price > maxPrice) {
          maxPrice = price;
        }
      })
      // Add the max price to the compare at price
      totalCompareAtPrice += maxPrice;

      // Print the max price that goes into the compare at price
      //console.log(`Max Price in Container: ${maxPrice}`);
    });
    //console.log('Total Price:', totalPrice);
    const compareAtPriceElement = document.querySelector('.product__price.product__price--compare');
    if (compareAtPriceElement) {
      compareAtPriceElement.textContent = '$' + totalPrice.toFixed(2);
    }
    var bundlePriceModifierEl = document.querySelector('.product-block--price')
    var bundlePriceModifier = bundlePriceModifierEl.getAttribute('data-discount-type')
    if ( bundlePriceModifier.length > 0 ){
      if ( bundlePriceModifier.includes('-') ){
        bundlePriceModifier = bundlePriceModifier.replace(/-/g, '')
        totalPrice = parseFloat(totalPrice - bundlePriceModifier)
      } else {
        bundlePriceModifier = bundlePriceModifier.replace(/%/g, '')
        totalPrice = parseFloat(totalPrice - (totalPrice * bundlePriceModifier)/100)
      }
    }
    
    // Print the total prices
    console.log('Total Price w. discount:', totalPrice);
    console.log('Total Compare At Price:', totalCompareAtPrice);
    // Update the price on the element with class 'product__price on-sale'
    const priceElement = document.querySelector('.product__price.on-sale');
    if (priceElement) {
      //debugger
      priceElement.textContent = '$' + totalPrice.toFixed(2);
    }

  }
  
  
});

function bundleDeselectLabels(varaintSelectorWrapper) {
  const productSwatches = varaintSelectorWrapper.querySelectorAll(
    ".custom-product-swatch"
  );
  productSwatches.forEach((swatch) => {
    swatch.querySelector("label").classList.remove("active");
  });
}

